import React, { useContext } from "react";
import { LanguageContext } from "../../../Contexts/LanguageContext";
import GinkgoBiloba from "../../../resources/images/Ginkgo-Biloba.jpg";
import PanaxGingseng from "../../../resources/images/Panax-Gingseng.jpg";
import Spirulina from "../../../resources/images/Spirulina.jpg";
import "./OurProducts.css";

const OurProducts = () => {
  const [isBangla, setIsBangla] = useContext(LanguageContext);
  return (
    <section className="our-products my-5 pb-5">
      <div className="container">
        <h1 className="text-center my-5 pt-5 p-3" style={{ fontWeight: 600 }}>
          {isBangla ? (
            <span>
              আমাদের <span style={{ color: "#4871FF" }}>পণ্যসমূহ</span>
            </span>
          ) : (
            <span>
              Our <span style={{ color: "#4871FF" }}>Products</span>
            </span>
          )}
        </h1>
        <div
          id="carouselExampleControls"
          className="carousel slide orange-bg"
          data-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item p-3 active">
              <div className="row align-items-center">
                <div className="col-md-7">
                  <h1 className="ml-2" style={{ color: "#4871FF" }}>
                    Ginkolet
                  </h1>
                  <h3 className="mt-3 ml-2">
                    {isBangla ? "জিঙ্কগো বিলোবা" : "Ginkgo Biloba"}
                  </h3>
                  <p className="mt-4 ml-2">
                    {isBangla
                      ? "জিঙ্কগো বিলোবাতে শক্তিশালী অ্যান্টিঅক্সিডেন্ট রয়েছে। এটি Inflammation কমাতে সহায়তা করে। Improves Blood Circulation(শুক্ষ রক্তনালিকা প্রসারিত করার মাদ্ধমে রক্ত চলাচল বৃদ্ধি করে)। হৃৎপিণ্ড সুস্থ করে। মস্তিস্কের কার্যকারিতা বৃদ্ধি করে। জীবনীশক্তি বৃদ্ধি করে। Asthma এবং COPD এর চিকিৎসায়ে অত্যন্ত কার্যকরী। মানসিক রোগের লক্ষন সমূহ দূর করে এবং Dementia দূর করে, Anxiety(দুশ্চিন্তা) দুর করে, Premenstrual syndrome দুর করে। বিষণ্ণতা, Headaches and Migraines, Sexual Dysfunctionএর চিকিৎসায় ব্যবহৃত হয়। দৃষ্টিশক্তি এবং চোখের স্বাস্থ্য Improve করে।"
                      : "Ginkgo Biloba contains powerful Antioxidants. It helps fight Inflammation. Improves Circulation and Heart health, Brain function and well-being, Asthma and COPD symptoms. Reduces symptoms of Psychiatric disorders and Dementia, Anxiety, PMS symptoms. Treats Depression, Headaches and Migraines, Sexual Dysfunction. Supports Vision and Eye health."}
                  </p>
                </div>
                <div className="col-md-5">
                  <img
                    src={GinkgoBiloba}
                    className="img d-block w-100"
                    alt="..."
                  />
                </div>
              </div>
            </div>
            <div className="carousel-item p-3">
              <div className="row align-items-center">
                <div className="col-md-7">
                  <h1 className="ml-2" style={{ color: "#4871FF" }}>
                    Panexgine
                  </h1>
                  <h3 className="mt-3 ml-2">
                    {isBangla ? "পানাক্স জিনসেং" : "Panax Gingseng"}
                  </h3>
                  <p className="mt-4 ml-2">
                    {isBangla
                      ? "পানাক্স জিনসেং আমাদের জন্য খুব উপকারী। পানাক্স জিনসেং Inflammation কমিয়ে দেয়। এটি খুব শক্তিশালী অ্যান্টিঅক্সিড্যান্ট। এটি ব্রেইন ফাংশন Improve করে। এটি ইরেকটাইল ডিসফংশনের সমস্যা দূর করে। এটি ইমিউন সিস্টেমকে বাড়িয়ে তোলে। এটি ক্যান্সার প্রতিরাধ করতে সহায়তা করে। এটি ক্লান্তি দুর করে এবং Energy Level বাড়াতে সহায়তা করে। এটি ব্লাড সুগার হ্রাস করে। Influenza চিকিৎসা এবং প্রতিরোধে সহায়তা করে।"
                      : "Panax Gingseng is very helpful for us. Panax Gingseng has potent Antioxidant that reduce Inflammation. It benefits Brain function. It improves Erectile dysfunction. It boosts the Immune system. It has potential benefits against Cancer. It helps fight Tiredness and increase Energy levels. It can lower Blood Sugar. Helps treat And prevent Influenza."}
                  </p>
                </div>
                <div className="col-md-5">
                  <img
                    src={PanaxGingseng}
                    className="img d-block w-100"
                    alt="..."
                  />
                </div>
              </div>
            </div>
            <div className="carousel-item p-3">
              <div className="row align-items-center">
                <div className="col-md-7">
                  <h1 className="ml-2" style={{ color: "#4871FF" }}>
                    Siplin
                  </h1>
                  <h3 className="mt-3 ml-2">
                    {isBangla ? "স্পিরুলিনা" : "Spirulina"}
                  </h3>
                  <p className="mt-4 ml-2">
                    {isBangla
                      ? "স্পিরুলিনা অনেক উচ্চ পুষ্টিগুণ সম্পন্ন। স্পিরুলিনাতে শক্তিশালী অ্যান্টিঅক্সিড্যান্ট এবং অ্যান্টি-ইনফ্ল্যামেটরি বৈশিষ্ট্য রয়েছে। এটি অ্যানিমিয়া বা রক্তশুন্যতার চিকিৎসায়ে অত্যন্ত কার্যকর। ক্ষতিকর এলডিএল এবং ট্রাইগ্লিসারাইডএর মাত্রা কমায়। স্পিরুলিনা ক্ষতিকর এলডিএল কোলেস্টেরলের জারণ কমায়। স্পিরুলিনাতে অ্যান্টি-ক্যান্সার Property রয়েছে। এটি রক্তচাপকেও হ্রাস করে। স্পিরুলিনা অ্যালার্জিক রাইনাইটিস হ্রাস করে, পেশীর শক্তি এবং পেশির সংকোচন প্রশারন (Muscle-tone & Muscle-elasticity) ক্ষমতা বৃদ্ধি করে এর ফলে শারীরিক শক্তি বৃদ্ধি করে। এটা ব্লাড সুগার নিয়ন্ত্রণ করে।"
                      : "Spirulina is extremely high in many nutrients. It has powerful Antioxidants and Anti-Inflammatory properties. Effective against Anemia. Lower “Bad” LDL and Triglyceride levels. Protects “Bad” LDL Cholesterol from Oxidation. It has Anti-Cancer properties. Reduce Blood Pressure. Improves symptoms of Allergic Rhinitis, Muscle Strength and Endurance. Improves Blood Sugar control."}
                  </p>
                </div>
                <div className="col-md-5">
                  <img
                    src={Spirulina}
                    className="img d-block w-100"
                    alt="..."
                  />
                </div>
              </div>
            </div>
          </div>
          <a
            className="carousel-control-prev"
            href="#carouselExampleControls"
            role="button"
            data-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Previous</span>
          </a>
          <a
            className="carousel-control-next"
            href="#carouselExampleControls"
            role="button"
            data-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
        <a className="all-products-btn ml-3 mt-4" href="/products">
          {isBangla ? "সকল পণ্যগুলো দেখুন" : "See All Products"}
        </a>
      </div>
    </section>
  );
};

export default OurProducts;
